export const stringIsNullOrEmpty = (value?: string | null): value is undefined => {
  return value === undefined || value === null || value === '';
};

export const numberIsNullOrZeroOrNaN = (value?: number | null): value is undefined => {
  return value === undefined || value === null || value === 0 || isNaN(value);
};
